import React, {useEffect, useState} from "react";
import styled from "./index.module.css";
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { useToast } from "../../context/ToastContext";
import { useTranslation } from "react-i18next";
// import { ConfirmDialog } from 'primereact/confirmdialog';
import UserConfigApi from "../../services/UserConfigApi";
import IApiResponseModel from "../../interfaces/IApiResponseModel";
import { useAuth } from "../../context/AuthContext";

const Config: React.FC = () => {
    const { userId } = useAuth();
    const { displayToast } = useToast();
    const { t: translate } = useTranslation("Config");
    const [config, SetConfig] = useState([]);

    const [simpleForm, SetSimpleForm] = useState<any>({
        userId: userId,
        image: "",
        imageMetaData: "",
        nickName: "",
    });

    const [selectedConfig, SetSelectedConfig] = useState<any>(null);
    const [form, SetForm] = useState<any>({
        userId: userId,
        platform: {label: "", id: 0},
        url: "",
        username: "",
        token: "",
        isActive: {name: '', value: false},
        projectName: ""
    });

    useEffect(() => {
        if (userId) {
            fetchProjects();
        } else {
            console.error("User ID é nulo!");
        }
    }, [userId]);


    const fetchProjects = async (): Promise<void> => {
        try {
          let configData = await UserConfigApi.GetUserConfigs(userId);
          configData.data = configData.data.map(
              (item: any) =>
              ({   ...item, configName: item.projectName, config: item.userConfigs}));
          if(configData?.success){
                SetSimpleForm({
                userId: userId, // Definindo userId
                id: configData.data[0].id,
                image: configData.data[0].image,
                imageMetaData: configData.data[0].imageMetaData,
                nickName: configData.data[0].nickName
              })
              SetConfig(configData.data[0].config);
              const activeConfig = configData.data[0].config.find((item: any) => item.isActive)
              if (!activeConfig) {
                  displayToast(
                      "info",
                      "Information",
                      translate ("UserDoesntHaveActiveConfig"),
                      false,
                      1000
                    );
                  return
              }
              SetSelectedConfig(activeConfig)
              SetForm({
                  id: activeConfig.id,
                  userId: activeConfig.userId,
                  platform: {label: activeConfig.platform},
                  url: activeConfig.baseUrl,
                  username: activeConfig.userName,
                  token: activeConfig.token,
                  isActive: activeConfig.isActive,
                  projectName: activeConfig.projectName
              })
          }
          else{
              SetConfig([]);
          }
        } catch (error) {
          console.error(("ErrorFetchingProjects"), error);
        }
      };

    const updateOrCreateConfig = async (): Promise<void> => {
        UserConfigApi.EditSimpleConfigs( simpleForm ).then((resp: IApiResponseModel) => {
           resp.successMessages.forEach((item: string) => {
               displayToast(
                   "success",
                   "Information",
                   item,
                   false,
                   3000
                 );
           });
           fetchProjects();
        }).catch((resp: IApiResponseModel) => {
           resp.errors.forEach((item: string) => {
               displayToast(
                   "error",
                   "Information",
                   item,
                   false,
                   5000
                 );
           });
        })
   }

    const handleImageChange = (event: any): void => {
        const file = event.target.files[0];
        if (file) {
        const reader = new FileReader();
        reader.onloadend = () => {
            if (reader.result != null) {
                var image64 = reader.result?.toString().split(',')[1]
                var imageMetaData = reader.result?.toString().split(',')[0]
                UserConfigApi.UpdateImage(image64, imageMetaData).then((resp: IApiResponseModel) => {
                    SetSimpleForm({...simpleForm, image: image64, imageMetaData: imageMetaData});
                    resp.successMessages.forEach((item: string) => {
                        displayToast(
                            "success",
                            "Information",
                            item,
                            false,
                            1000
                          );
                    });
                 }).catch((resp: IApiResponseModel) => {
                    resp.errors.forEach((item: string) => {
                        displayToast(
                            "error",
                            "Information",
                            item,
                            false,
                            5000
                          );
                    });
                 })
            }
        };
        reader.readAsDataURL(file);
        }
    };

    console.log(form, config, selectedConfig)
    return (
        <>
        <div className={`${styled.grid}`}>
            <form action="">
            <div className="p-inputgroup flex-1">
                <div className={`${styled.photoGrid}`}>
                    <img className={`${styled.photo}`} src={`${simpleForm.imageMetaData},${simpleForm.image}`} alt="" style={{ width: '100px', height: '100px'}}/>
                    <label className={`${styled.archiveLabel}`} htmlFor="archive">
                        {translate("ChangePicture")}
                        <i className="pi pi-camera" style={{ color: 'white', marginLeft: '5%'}}></i>
                    </label>
                    <input type="file" id="archive" onChange={handleImageChange} accept="image/*"/>
                </div>
                <div className={`${styled.gap} card flex justify-content-center align-items-center md: w-40rem`}>
                    <span className="p-float-label">
                        <InputText id="username" className={`${styled}  md: h-3rem w-10rem`} value={simpleForm.nickName} onChange={(e) => SetSimpleForm({...simpleForm, nickName: e.target.value})}/>
                        <label htmlFor="username" className={`${styled}`}>{translate("Nickname")}</label>
                    </span>
                    <Button className={`${styled.buttonOne}`} onClick={() => updateOrCreateConfig()} label={translate("Save")} type="button" icon="pi pi-check" style={{ backgroundColor: 'var(--primary-color)', color: 'white'}}/>
                </div>
            </div>
            </form>
        </div>
    </>
    );
  };

  export default Config;
